import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import { extensionDecorator, MarkExtension, ExtensionTag, toggleMark, markInputRule, LEAF_NODE_REPLACING_CHARACTER, markPasteRule } from '@remirror/core';

var _dec, _class, _temp;
/**
 * Add a `code` mark to the editor. This is used to mark inline text as a code
 * snippet.
 */

var CodeExtension = (_dec = /*#__PURE__*/extensionDecorator({}), /*#__PURE__*/_dec(_class = (_temp = class CodeExtension extends MarkExtension {
  constructor() {
    super(...arguments);

    _defineProperty(this, "tags", [ExtensionTag.Code, ExtensionTag.MarkSupportsExit]);
  }

  get name() {
    return 'code';
  }

  createMarkSpec(extra) {
    return {
      attrs: extra.defaults(),
      parseDOM: [{
        tag: 'code',
        getAttrs: extra.parse
      }],
      toDOM: mark => ['code', extra.dom(mark), 0]
    };
  }

  createKeymap() {
    return {
      'Mod-`': toggleMark({
        type: this.type
      })
    };
  }

  createCommands() {
    return {
      /**
       * Toggle the current selection as a code mark.
       */
      toggleCode: () => toggleMark({
        type: this.type
      })
    };
  }

  createInputRules() {
    return [markInputRule({
      regexp: new RegExp("(?:`)([^`".concat(LEAF_NODE_REPLACING_CHARACTER, "]+)(?:`)$")),
      type: this.type,
      ignoreWhitespace: true
    })];
  }

  createPasteRules() {
    return [markPasteRule({
      regexp: /`([^`]+)`/g,
      type: this.type
    })];
  }

}, _temp)) || _class);

export { CodeExtension };
